import { render, staticRenderFns } from "./Inspector.vue?vue&type=template&id=6c866520&scoped=true&"
import script from "./Inspector.vue?vue&type=script&lang=js&"
export * from "./Inspector.vue?vue&type=script&lang=js&"
import style0 from "./Inspector.vue?vue&type=style&index=0&id=6c866520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c866520",
  null
  
)

export default component.exports